import { HexColorInput as ReactHexColorInput } from 'react-colorful'
import Styles from 'almanac-ui/TextInputField/Input.module.scss'
import { InputProps } from 'almanac-ui/TextInputField/Types'
import cx from 'classnames'
import { ComponentProps, useState } from 'react'
import { useFocus } from '@react-aria/interactions'
import { mergeProps } from '@react-aria/utils'

interface Props
  extends Pick<InputProps, 'size' | 'isValid' | 'withBorder' | 'className'>,
    Omit<ComponentProps<typeof ReactHexColorInput>, 'size'> {}

export const HexColorInput = ({ size = 'lg', isValid = true, withBorder = true, className, ...rest }: Props) => {
  const [isFocused, setIsFocused] = useState(false)
  const { focusProps } = useFocus({ onFocusChange: (isFocused) => setIsFocused(isFocused) })

  return (
    <ReactHexColorInput
      className={cx(Styles.input, Styles[size], className, {
        [Styles.focused]: isFocused,
        [Styles.invalid]: !isValid,
        [Styles.withBorder]: withBorder,
      })}
      {...mergeProps(rest, focusProps)}
    />
  )
}
